// extracted by mini-css-extract-plugin
module.exports = {"assetInput":"styles_assetInput__xcFIu"};